import {
  Button,
  Col,
  Form,
  Layout,
  Row,
  Select,
  Input,
  DatePicker,
  Icon,
} from "antd";
import React, { Component } from "react";
const { Content } = Layout;

class BlackListFilters extends Component {
  state = {
    date1: null,
    date2: null,
  };

  eventData = [
    {
      id: 1,
      label: "DISABLED",
      value: "disabled",
    },
    {
      id: 2,
      label: "ENABLED",
      value: "enabled",
    },
  ];

  onFinish = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const finalOutput = {
          ...values,
        };

        if (values["start"] && !values["end"]) {
          finalOutput["created "] =
            values["start"].format("YYYY-MM-DD") +
            ":" +
            values["start"].format("YYYY-MM-DD");
        }

        if (values["end" && !values["start"]]) {
          finalOutput["created "] =
            values["end"].format("YYYY-MM-DD") +
            ":" +
            values["end"].format("YYYY-MM-DD");
        }

        if (values["start"] && values["end"]) {
          finalOutput["created"] =
            values["start"].format("YYYY-MM-DD") +
            ":" +
            values["end"].format("YYYY-MM-DD");
        }

        delete finalOutput.start;
        delete finalOutput.end;

        const parsedJson = JSON.stringify(finalOutput);

        //callback
        this.props.onSubmit(parsedJson);
      }
    });
  };

  onResetBtn = () => {
    this.setState({ date1: null, date2: null });
    this.props.form.resetFields();
    this.props.onSubmit();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { adminList } = this.props;

    if (adminList.length > 0 && !adminList.find((r) => r.id === 1)) {
      adminList.unshift({
        id: 1,
        firstname: "Administrator",
        lastname: "System",
      });
    }

    return (
      <Content
        style={{
          background: "#fff",
          padding: 24,
          margin: "16px 0",
          minHeight: 300,
        }}
      >
        <h2>Universal Blacklist Number</h2>
        <Form
          name="filter-forms"
          colon={false}
          onSubmit={this.onFinish}
          hideRequiredMark
        >
          <Row gutter={8}>
            <Col xl={8}>
              <Form.Item name="msisdn" label="เบอร์โทรศัพท์">
                {getFieldDecorator("msisdn")(
                  <Input
                    prefix={
                      <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    placeholder="กรอกเบอร์ที่ต้องการค้นหา"
                  />
                )}
              </Form.Item>
            </Col>
            <Col xl={8}>
              <Form.Item name="status" label="สถานะ">
                {getFieldDecorator("status")(
                  <Select showSearch allowClear placeholder="เลือกสถานะ">
                    {this.eventData.map((c) => {
                      const { label, value, id } = c;

                      return (
                        <Select.Option key={id} value={value}>
                          {label}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col xl={8}>
              <Form.Item name="created_by" label="ผู้ดูแล">
                {getFieldDecorator("created_by")(
                  <Select showSearch allowClear placeholder="เลือกผู้ดูแล">
                    {adminList.map((c) => {
                      const { id, firstname, lastname } = c;
                      const name = firstname + " " + lastname;
                      return (
                        <Select.Option key={id} value={id}>
                          {name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col xl={6}>
              <Form.Item name="start" label="วันที่">
                {getFieldDecorator("start")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.date2) {
                        return c > this.state.date2;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ date1: d })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xl={6}>
              <Form.Item name="end" label="&nbsp;">
                {getFieldDecorator("end")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.date1) {
                        return c <= this.state.date1;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ date2: d })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col xl={6} offset={6} style={{ textAlign: "end" }}>
              <Form.Item label="&nbsp;">
                <Button
                  style={{ width: "120px", margin: "0 4px 0 4px" }}
                  onClick={() => this.onResetBtn()}
                >
                  Reset
                </Button>
                <Button
                  style={{ width: "120px", margin: "0 4px 0 4px" }}
                  type="primary"
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Content>
    );
  }
}

export default Form.create({ name: "blacklist_filters" })(BlackListFilters);



// WEBPACK FOOTER //
// ./src/containers/BlackList/form.js